export function serializeShopCatalogQueryParams(
  params?: object,
): string {
  const serialized = new URLSearchParams();

  for (const [key, value] of Object.entries(params ?? {})) {
    if (value === undefined) {
      continue;
    }

    if (key === "attribute" && isAttributeFilterMap(value)) {
      for (const [attributeUuid, itemUuids] of Object.entries(value)) {
        for (const itemUuid of itemUuids) {
          serialized.append(`attribute[${attributeUuid}][]`, itemUuid);
        }
      }

      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        serialized.append(key, item === null ? "null" : String(item));
      }

      continue;
    }

    serialized.append(key, value === null ? "null" : String(value));
  }

  return serialized.toString();
}

function isAttributeFilterMap(value: unknown): value is Record<string, string[]> {
  return typeof value === "object"
    && value !== null
    && !Array.isArray(value)
    && Object.values(value).every((items) => (
      Array.isArray(items) && items.every((item) => typeof item === "string")
    ));
}
